"use client";

import dynamic from "next/dynamic";

export default dynamic(() => import("./AutoScrollContainer"), {
  ssr: false,
  loading: () => null,
});
